import { FilterMethod } from "@/generated/company-search";

/**
 * Upload state machine states.
 * IDLE → UPLOADING → PROCESSING (hermes reads the file) → SUCCESS/ERROR
 */
export type KnownCompaniesUploadState =
  | "IDLE"
  | "UPLOADING"
  | "PROCESSING"
  | "SUCCESS"
  | "ERROR";

export type KnownCompaniesSlice = {
  uploadState: KnownCompaniesUploadState;
  /** hermes-assigned identifier of the HG ID file stored in S3 */
  identifier: string | null;
  fileName: string | null;
  /** Data rows in the uploaded file */
  totalRows: number | null;
  /** Rows that are not a valid HG ID */
  invalidRows: number | null;
  /** Valid HG IDs that exist as companies */
  matchedRows: number | null;
  /** Whether to include corporate hierarchy of the listed companies */
  includeHierarchy: boolean;
  /** FILTER keeps only listed companies; EXCLUDE_MATCHED hides them (Whitespace) */
  filterMethod: FilterMethod;
  error: string | null;
  /** ISO timestamp of the upload */
  uploadedAt: string | null;
};

export const defaultKnownCompaniesSlice: KnownCompaniesSlice = {
  uploadState: "IDLE",
  identifier: null,
  fileName: null,
  totalRows: null,
  invalidRows: null,
  matchedRows: null,
  includeHierarchy: false,
  filterMethod: FilterMethod.FILTER,
  error: null,
  uploadedAt: null,
};
